// import GoogleMapReact from 'google-map-react';
import React, { useEffect, useState } from 'react';
import {
  GoogleMap as GoogleMapReact,
  Marker,
  withGoogleMap,
  withScriptjs,
} from 'react-google-maps';

const key = process.env.REACT_APP_GGMAP_KEY || '';

const GoogleMapMarker =  withScriptjs(
  withGoogleMap((props) => {
  const { listLocation = [], focusLocation } = props;
  const [listPos, setListPos] = useState([]);
  const [focusLoc, setFocusLoc] = useState(null);

  useEffect(() => {
    if (focusLocation) {
      const position = focusLocation.position.split(',').map((j) => Number(j.trim()));
      const posFocus = { lng: position[0], lat: position[1] };
      setFocusLoc(posFocus);
    } else {
      setFocusLoc(listPos[0]);
    }
  }, [focusLocation]);

  useEffect(() => {
    if (listLocation.length > 0) {
      const listP = listLocation.map((i) => {
        const position = i.position.split(',').map((j) => Number(j.trim()));
        return { lng: position[0], lat: position[1], title: i.address };
      });
      setListPos(listP);
    }
  }, [listLocation]);

  return (
    <>
      {listPos.length > 0 && (
        <GoogleMapReact
          defaultZoom={15}
          defaultCenter={listPos[0]}
          zoom={focusLoc ? 15 : 10}
          center={focusLoc || listPos[0]}
          options={{ lang: 'vi', region: 'vi' }}
        >
          {listPos.map((i, index) => {
            return <Marker key={index} position={{ lat: i.lat, lng: i.lng }} title={i.title} />;
          })}
        </GoogleMapReact>
      )}
    </>
  );
}));

const WrapperMap =(props) => {
    return <GoogleMapMarker {...props} />;
  };

const GoogleMap = ({ listLocation, focusLocation }) => {
  return (
    <WrapperMap
      googleMapURL={`https://maps.googleapis.com/maps/api/js?key=AIzaSyAHC-8ACvOSvk6iVxyW2rw6eAjodWDxJGU&v=3.exp&libraries=geometry,drawing,places&language=vi`}
      loadingElement={<div style={{ height: '100%' }} />}
      containerElement={<div style={{ height: '400px' }} />}
      mapElement={<div style={{ height: '100%' }} />}
      listLocation={listLocation}
      focusLocation={focusLocation}
    />
  );
};
export default GoogleMap;
